import Axios from "axios";
import React, { useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { Nav, NavDropdown } from "react-bootstrap";
import { notify } from "react-notify-toast";
import { UserContext } from "../../Context/UserContext";
import "./links/navLinks.css";

export default function UserAdministration() {
  const history = useHistory();
  const user = useContext(UserContext);
  const userdata = JSON.parse(localStorage.getItem("userdata") || "{}");

  const delete2FA = () => {
    if (window.confirm("Eliminar 2FA?")) {
      Axios.put(
        "/api/user/2fa/remove",
        {},
        { headers: { "auth-token": localStorage.getItem("JWT") || " " } }
      ).then(({ data }) => {
        if (data.success) {
          notify.show(data.message, "success");
          const storedUser = JSON.parse(
            localStorage.getItem("userdata") || "{}"
          );
          delete storedUser.has2FA;
          localStorage.setItem("userdata", JSON.stringify(storedUser));
          history.push("/");
        } else {
          notify.show("Error eliminando 2FA", "error");
        }
      });
    }
  };

  return (
    <Nav className="rc-user-nav">
      {user.username ? (
        <NavDropdown
          id="Users"
          alignRight
          className="rc-nav-dropdown rc-user-dropdown"
          title={
            <span className="d-inline-flex align-items-center">
              <span className="rc-user-avatar mr-2">
                <i className="fas fa-user" />
              </span>
              <span className="rc-user-name">{user.username}</span>
            </span>
          }
        >
          <div className="rc-nav-section-header">Cuenta</div>
          <NavDropdown.Divider className="rc-nav-menu-divider" />
          <NavDropdown.Item
            as={Link}
            to={`/users/pswrdChange/${user.userId}`}
            className="rc-nav-item"
          >
            <span className="rc-nav-item-icon">
              <i className="fas fa-key" />
            </span>
            <span>Cambiar contraseña</span>
          </NavDropdown.Item>
          {!userdata.has2FA ? (
            <NavDropdown.Item
              href="/users/2fa/generate"
              className="rc-nav-item"
            >
              <span className="rc-nav-item-icon rc-nav-item-icon-success">
                <i className="fas fa-shield-alt" />
              </span>
              <span>Agregar 2Factor Auth.</span>
            </NavDropdown.Item>
          ) : user.hasVerified2FA ? (
            <NavDropdown.Item
              onClick={delete2FA}
              className="rc-nav-item"
            >
              <span className="rc-nav-item-icon rc-nav-item-icon-warning">
                <i className="fas fa-unlock-alt" />
              </span>
              <span>Eliminar 2FA</span>
            </NavDropdown.Item>
          ) : null}
          <NavDropdown.Divider className="rc-nav-menu-divider" />
          <NavDropdown.Item
            as={Link}
            to="/users/logout"
            className="rc-nav-item"
          >
            <span className="rc-nav-item-icon rc-nav-item-icon-accent">
              <i className="fas fa-sign-out-alt" />
            </span>
            <span>Cerrar Sesión</span>
          </NavDropdown.Item>
        </NavDropdown>
      ) : (
        <Link className="nav-link rc-nav-direct-link" to="/users/login">
          <i className="fas fa-sign-in-alt rc-nav-title-icon" />
          <span>Iniciar sesión</span>
        </Link>
      )}
    </Nav>
  );
}
